export const getFAQs = (data: Array<any>): any => {
  const faq = data?.[0];
  const header = faq?.header;
  const FAQBlocks = faq?.faqblock;

  return {
    header,
    FAQBlocks,
    id: faq?.id,
  };
};
